import { createApp } from 'vue';
import PersonOverlay from './vue/person-overlay.vue';
import { context } from './person-overlay.config.yml';


const app = createApp(PersonOverlay, context);
app.mount('#person-overlay-root');
